import ArrowRight from '@img/icons/arrow-right.svg';
import Cross from '@img/icons/icon-cross.svg';
import LocationPin from '@img/icons/icon-location-pin.svg';
import Plus from '@img/icons/plus.svg';
import Upload from '@img/icons/upload.svg';
import Loader from '@stories/Elements/Loaders/Loader/Loader';
import React from 'react';
import { ButtonElement, ButtonIcon, ButtonText } from './Button.styles';
const Button = ({ id, text, onClick, icon = 'arrow', iconPosition = 'after', size = 'default', disabled = false, progress = false, theme = 'green', error = false, type = 'button', centreText = true, cursor, disableVerticalMovementOnHover = false, className, style, attributes, children, }) => {
    const _onClick = (event) => {
        if (!onClick) {
            return;
        }
        if (disabled || progress) {
            event.preventDefault();
            return;
        }
        onClick(event);
    };
    if (children) {
        return (React.createElement(ButtonElement, Object.assign({ id: id, className: className, type: type, theme: theme, "data-icon": icon, "data-icon-position": iconPosition, reverseIconAnimation: icon === 'arrow-back', "data-size": size, disabled: disabled, "data-progress": progress, onClick: _onClick, error: error, centreText: centreText, cursor: cursor, disableVerticalMovementOnHover: disableVerticalMovementOnHover, style: style }, attributes), children));
    }
    return (React.createElement(ButtonElement, Object.assign({ id: id, className: className, type: type, theme: theme, "data-icon": icon, "data-icon-position": iconPosition, reverseIconAnimation: icon === 'arrow-back', "data-size": size, disabled: disabled, "data-progress": progress, onClick: _onClick, error: error, centreText: centreText, cursor: cursor, disableVerticalMovementOnHover: disableVerticalMovementOnHover, style: style }, attributes),
        iconPosition === 'before' ? renderIcon(progress ? 'progress' : icon, iconPosition, size) : null,
        text && React.createElement(ButtonText, null, text),
        iconPosition === 'after' ? renderIcon(progress ? 'progress' : icon, iconPosition, size) : null));
};
function renderIcon(icon, iconPosition, size) {
    switch (icon) {
        case 'none': {
            return null;
        }
        case 'progress': {
            return (React.createElement(ButtonIcon, { position: iconPosition, size: size },
                React.createElement(Loader, { inline: true, width: 2, size: 18, theme: "current" })));
        }
        case 'upload': {
            return (React.createElement(ButtonIcon, { position: iconPosition, size: size },
                React.createElement(Upload, null)));
        }
        case 'plus': {
            return (React.createElement(ButtonIcon, { position: iconPosition, size: size },
                React.createElement(Plus, null)));
        }
        case 'arrow-down': {
            return (React.createElement(ButtonIcon, { position: iconPosition, rotateAngle: 90, size: size },
                React.createElement(ArrowRight, null)));
        }
        case 'arrow-back': {
            return (React.createElement(ButtonIcon, { position: iconPosition, rotateAngle: 180, size: size },
                React.createElement(ArrowRight, null)));
        }
        case 'arrow-up': {
            return (React.createElement(ButtonIcon, { position: iconPosition, rotateAngle: -90, size: size },
                React.createElement(ArrowRight, null)));
        }
        case 'cross': {
            return (React.createElement(ButtonIcon, { position: iconPosition, size: size },
                React.createElement(Cross, null)));
        }
        case 'pin': {
            return (React.createElement(ButtonIcon, { position: iconPosition, size: size, icon: icon, limitIconMovement: true },
                React.createElement(LocationPin, null)));
        }
        default:
        case 'arrow': {
            return (React.createElement(ButtonIcon, { position: iconPosition, size: size },
                React.createElement(ArrowRight, null)));
        }
    }
}
export default Button;
